import { io } from 'socket.io-client'

export const IO_CHANNELS = {
  APP_BOOTSTRAP: 'app-bootstrap',
  SLIDE_SETTING: 'slide-setting',
  ZODIAC_PEOPLE: 'zodiac-people',
  ZODIAC_RANKING: 'zodiac-ranking',
  SECONDARY_PAGE: 'secondary-page',
  BIRTHDAY_THIS_MONTH: 'birthday-this-month',
  SALES_FIGURE: 'sales-figure'
}

export const initSocket = () => {
  const socket = io(window.$app.SERVER_URL)
  socket.on('hello', res => {
    console.log(res)
  })
  return socket
}
